import React from 'react'
import { SelectMui } from 'src/components/SelectMui'
import { useSelector } from 'src/utils/store'
import { receivementStatus } from 'src/utils/mappers/mapReceivementStatus'
import { useDispatch } from 'react-redux'
import { actions } from '../../ReceivementOverviewListState'
import { useReceivement } from 'src/hooks/useReceivement'

export const StatusFilterSelect = () => {
  const dispatch = useDispatch()
  const { supervisorBadge } = useReceivement({ validateSupervisor: true })
  const idStatus = useSelector((state) => state.receivementOverviewList.idStatus)
  const receivementStatusList = useSelector((state) => state.receivementOverviewList.receivementStatusList)

  const resolveStatusOptions = () =>
    Object.values(receivementStatusList).map((status) => ({
      ...status,
      description: receivementStatus[status.description],
    }))

  const setIdStatus = React.useCallback((value: string) => {
    dispatch(actions.updateOverviewFilterField({ key: 'idStatus', value }))
  }, [dispatch])

  React.useEffect(() => {
    if (supervisorBadge && receivementStatusList.length === 0) dispatch(actions.getReceivementStatusList({ badge: supervisorBadge }))
    setIdStatus(idStatus || '')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, receivementStatusList, setIdStatus, supervisorBadge])

  return (
    <SelectMui
      label='Status'
      options={resolveStatusOptions()}
      value={idStatus}
      onChange={(event) => setIdStatus(event.target.value as string)}
    />
  )
}
